import type { BannersCarouselItem } from '../../components/TopAreaBanner/components/BannersCarousel/types';
import type { VipAccessResponse } from '../../models';

interface IsLoadingParams {
  topBannerVisible: boolean;
  isAnonymousWithStore: boolean;
  loadingVipAccess: boolean;
  orderOnBehalfVisible: boolean;
  isLoadingTopBanner: boolean;
}

export const isLoading = ({
  isAnonymousWithStore,
  loadingVipAccess,
  orderOnBehalfVisible,
  topBannerVisible,
  isLoadingTopBanner,
}: IsLoadingParams): boolean =>
  loadingVipAccess ||
  (!isAnonymousWithStore && !orderOnBehalfVisible && !topBannerVisible) ||
  // isLoadingTopBanner could be deleted when all markets are migrated to the new banners
  (isAnonymousWithStore && isLoadingTopBanner && !topBannerVisible);

export const isOrderOnBehalfVisible = (orderOnBehalfData: VipAccessResponse | undefined): boolean =>
  !!orderOnBehalfData?.VipAccessData?.ConsultantName &&
  !!orderOnBehalfData.VipAccessData.ConsultantNumber &&
  !!orderOnBehalfData.VipAccessLabels?.ConsultantChangeConsultantNumber &&
  orderOnBehalfData.VipAccessData.Links.length > 0;

export const isTopAreaBannerVisible = (bannersData: BannersCarouselItem[] | undefined): boolean =>
  !!bannersData && bannersData.length > 0;

interface ShouldSkipBenefitBannerFetchParams {
  enableTopAreaBanner?: boolean;
  isAnonymousWithStore: boolean;
  loadingSegmentationData: boolean;
  orderOnBehalfVisible: boolean;
}

export const shouldSkipBenefitBannerFetch = ({
  enableTopAreaBanner,
  isAnonymousWithStore,
  loadingSegmentationData,
  orderOnBehalfVisible,
}: ShouldSkipBenefitBannerFetchParams): boolean =>
  loadingSegmentationData || orderOnBehalfVisible || !enableTopAreaBanner || isAnonymousWithStore;
